import { API } from "../api/apis";
import  { HttpClient }  from "../../services/api/httpclient.service";


export class ChatService extends HttpClient {

    constructor() {
        super()
    }

    public async TALKWITHCHAT(payload: any) {        
        try {            
            const response = await this.post('/chat/TalkWithChat', payload);            
            return response
        } catch (error: any) {
            console.error('Chat service error:', error);
            throw error;
        }        
      } 


    public async GETQUESTIONSTEPS(payload: { exercise_id: number, selected_question: string, selected_question_id: number }) {
        try {
            const response = await this.post('/chat/get_question_steps', payload);
            return response; // Ensure to return the response data
        } catch (error: any) {
            console.error('Chosen question API error:', error.response?.data || error.message);
            throw error;
        }
    }

    public async SOLUTIONBYSTEPS(payload: { exercise_id: number, solution_steps: string, selected_question: string, all_steps_solution: boolean }) {
        try {
            const response = await this.post('/chat/solution_by_steps', payload);
            return response; // Ensure to return the response data
        } catch (error: any) {
            console.error('Chosen question API error:', error.response?.data || error.message);
            throw error;
        }
    }

    public async GETEXERCISECONTENT(exercise_id: number ) {
        try {
            const response = await this.get(`/data/get_exercise_content/${exercise_id}`);
            return response;
        } catch (error: any) {
            console.error('Get exercise content API error:', error.response?.data || error.message);
            throw error;
        }
    }



    public async EXPLAINSTEPSOLUTION(requestData: { exercise_id: number, prev_response: string, selected_question: string, selected_step: string }) {
        try {
            const response = await this.post('/chat/explain_step_solution_details', requestData);
            return response;
        } catch (error: any) {
            console.error('Chosen question API error:', error.response?.data || error.message);
            throw error;
        }
    }

    public async TALKWITHCHATBYIMAGE(image: string) {
        try {
            const response = await this.post("/chat/TalkWithChat_by_image", {image: image});
            return response;
        } catch (error) {
            console.error("Error in TALKWITHCHATBYIMAGE:", error);
            throw error;
        }
    }

    public async SOLVE_SPECIFIC_IMAGE_QUESTION(payload: any) {
        try {
             const response = await this.post("/chat/solve_specific_image_question", payload);
             return response;
        } catch (error) {
             console.error("Error in SOLVE_SPECIFIC_IMAGE_QUESTION:", error);
             throw error;
        }
    }


    public async TALKWITHAGENT_V2(payload: {
        message: string;
        context?: {
            current_page?: string;
            step_type?: string;
            lesson_id?: number;
            topic?: string;
            level_id?: number;
            metadata?: any;
        };
        history: any[];
        session_id?: string;
    }) {
        try {
            const response = await this.post('/agent/chat', payload);
            return response;
        } catch (error: any) {
            console.error('Agent V2 chat service error:', error);
            throw error;
        }
    }

    public async sendActivity(payload: { page: string; metadata?: any }) {
        try {
            const response = await this.post('/session/activity', payload);
            return response;
        } catch (error: any) {
            console.error('Session activity log error:', error);
            throw error;
        }
    }

}